module.exports = __webpack_public_path__ + "img/info-square-fill.60c2b82a.svg";